document.addEventListener('DOMContentLoaded', function () {
    // Select the first element with the class 'desktop-hero-image'
    var desktopImage = document.querySelector('.desktop-hero-image');
       // Select the first element with the class 'mobile-hero-image'
    var mobileImage = document.querySelector('.mobile-hero-image');

    if (window.innerWidth >= 1024 && desktopImage) {
      // If the screen width is at least 1024px (assuming desktop)
      desktopImage.setAttribute('fetchpriority', 'high');
      desktopImage.setAttribute('loading', 'eager');
      mobileImage.setAttribute('fetchpriority', 'low');
      mobileImage.setAttribute('loading', 'lazy');
    }

 

    if (window.innerWidth < 1024 && mobileImage) {
      // If the screen width is less than 1024px (assuming mobile)
      mobileImage.setAttribute('fetchpriority', 'high');
      mobileImage.setAttribute('loading', 'eager');
      desktopImage.setAttribute('fetchpriority', 'low');
      desktopImage.setAttribute('loading', 'lazy');
    }
  });
